module.exports = __webpack_public_path__ + "img/1.4a3ae177.png";